<template>
  <app-layout>
    <a-spin :spinning="submitting">

      <jet-confirmation-modal :show="confirmModal" @close="confirmModal = false">
        <template #title>
          Remove user from your plan
        </template>

        <template #content>
          Are you sure you want to delete this user? This user will be removed from all teams.
        </template>

        <template #footer>
          <jet-secondary-button @click="confirmModal = false">
            Cancel
          </jet-secondary-button>

          <jet-danger-button class="ml-2" @click="confirmDelete">
            Remove
          </jet-danger-button>
        </template>
      </jet-confirmation-modal>


      <div class="h-full flex">
        <div class="flex flex-col w-0 flex-1">
          <main class="flex-1 relative focus:outline-none px-8">
            <bread-nav :pages="pages"></bread-nav>

            <div class="pt-8 pb-16">
              <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">


                <div>
                  <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                      Current Plan
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                      {{ this.plan }}
                      <div class="text-sm">
                        <div v-if="this.is_per_seat">
                          ${{ this.unit_price }} {{ this.unit }} / user / month
                        </div>
                        <div v-else>
                          ${{ this.unit_price }} {{ this.unit }} / month
                        </div>
                      </div>
                    </dd>
                  </div>

                  <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                    <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                      <dt class="text-sm font-medium text-gray-500 truncate">
                        Total Teams
                      </dt>
                      <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ this.total_teams }}
                      </dd>
                    </div>

                    <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                      <dt class="text-sm font-medium text-gray-500 truncate">
                        Total Unique Members
                      </dt>
                      <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ this.used }} {{ this.allowed_size ? '/ ' + this.allowed_size : null }}
                      </dd>
                    </div>


                    <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                      <dt class="text-sm font-medium text-gray-500 truncate">
                        Est. Cost
                      </dt>
                      <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        <div v-if="this.is_per_seat">
                          ~${{ this.unit_price * this.used }} {{ this.unit }} / month
                        </div>
                        <div v-else>
                          ${{ this.unit_price }} {{ this.unit }} / month
                        </div>
                      </dd>
                    </div>
                  </dl>


                </div>


                <div class="py-2 mt-5 flex flex-col">
                  <div v-if="this.users.length > 0" class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">

                        <table class="min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                          <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              #
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Member
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Details
                            </th>
                          </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="(user,index) in this.users" :key="user.email">
                            <td class="px-6 py-4 whitespace-nowrap">
                              <div class="flex items-center">
                                {{ index + 1 }}
                              </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap">
                              <div class="flex items-center">
                                <div class="flex-shrink-0 h-10 w-10">
                                  <img class="h-10 w-10 rounded-full" :src="user.profile_photo_path" alt="">
                                </div>
                                <div class="ml-4">
                                  <div class="text-sm font-medium text-gray-900">
                                    {{ user.name }}
                                  </div>
                                  <div class="text-sm text-gray-500">
                                    {{ user.email }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <div v-if="this.$page.props.user.id != user.id">
                                <div v-if="user.teams">
                                  <ul>
                                    <li v-for="team in user.teams">
                                      {{ team.name }} ({{team.membership.role}})
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div v-else class="text-gray-500 font-bold">Owner</div>
                            </td>
                          </tr>

                          <!-- More people... -->
                          </tbody>
                        </table>


                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <no-data></no-data>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </a-spin>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import BreadNav from "@/Components/BreadNav/BreadNav";
import {ref} from 'vue';

const pages = [
  {name: 'Billing', href: '#', current: false},
  {name: 'User Seat Usage', href: '#', current: true},
]

import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import {message} from "ant-design-vue";


import {
  UsersIcon,
  MailIcon,
} from "@heroicons/vue/outline";
import NoData from "@/Components/NoData/NoData";

export default {
  props: [
    'unit_price',
    'is_per_seat',
    'unit',
    'used',
    'plan',
    'users',
    'total_teams',
    'allowed_size',
    'team_map'
  ],
  data() {
    return {};
  },
  beforeMount() {

  },
  created() {
  },
  setup(props, context) {

    const selected = ref(null);
    const submitting = ref(false);
    const confirmModal = ref(false);
    const removeClicked = (user) => {
      selected.value = user;
      confirmModal.value = true;
    }

    const confirmDelete = () => {
      submitting.value = true;
      confirmModal.value = false;

      axios
          .post(route("billing.usage.delete"), {
            user_id: selected.value.id
          })
          .then((response) => {
            submitting.value = false;
            message.success('Successfully removed', 5);
            window.location.reload();
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error('Our system cannot delete it, please contact us.', 5);
          });
    }
    return {
      confirmDelete,
      submitting,
      removeClicked,
      confirmModal,
      pages
    }
  },

  methods: {},
  components: {
    NoData,
    JetConfirmationModal,
    JetDangerButton,
    JetSecondaryButton,
    MailIcon,
    UsersIcon,
    BreadNav,
    AppLayout,
  },
};
</script>
